import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ArcGrid, {
  ArcGridFunc,
  CustomAttachFileIconRenderer, CustomTitleRenderer,
  GridColumn
} from "app/components/arc/ArcGrid";
import { PstatModel, PstatSearchModel } from "app/model/info/pstat";
import ArcInput, { ArcInputChangeResult } from "app/components/arc/ArcInput";
import ArcButton, { ButtonType } from "app/components/arc/ArcButton";
import moment from "moment";
import { Constant } from "app/constants/constant";
import { PstatService } from "app/services/info/pstatService";
import { ResponseResultCode } from "app/model/response-api";
import { BltnbClCd, PrstsCd } from "app/model/common/code";
import i18n from "i18next";
import ArcSelectbox from "app/components/arc/ArcSelectbox";
import { useTranslation } from "react-i18next";
import { UserInfoUtil } from "app/utils/userInfoUtil";
import { AuthConstant } from "app/constants/authConstant";
import { useAppSelector } from "app/store/hook";
import ArcTitle from "app/components/arc/ArcTitle";

export default function Info004() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const userInfo = useAppSelector(state => state.userInfo.userInfo);

  const initialSearch = new PstatSearchModel(BltnbClCd.API);
  const [search, setSearch] = useState<PstatSearchModel>(initialSearch);

  const prstsOption = [
    { label: `${t(`info.code.prstsCd.PROCESS`)}`, value: PrstsCd.PROCESS },
    { label: `${t('info.code.prstsCd.COMPLETE')}`, value: PrstsCd.COMPLETE },
  ];

  const gridColumn: GridColumn[] = [
    {
      header: "제목",
      name: "titlNm",
      minWidth: 500,
      renderer: {
        type: CustomTitleRenderer
      }
    },
    // {
    //   header: "첨부파일",
    //   align: 'center',
    //   name: 'file',
    //   minWidth: 50,
    //   width: 100,
    //   renderer: {
    //     type: CustomAttachFileIconRenderer,
    //   }
    // },
    {
      header: '작성업체',
      name: 'regrNm',
      align: 'center',
      minWidth: 200,
      width: 200,
    },
    {
      header: "등록일",
      name: "regDate",
      align: 'center',
      minWidth: 150,
      width: 200,
      formatter: (e: any) => moment(e.value).format(Constant.FORMAT_YMD)
    },
    {
      header: '문의상태',
      name: "prstsCd",
      align: 'center',
      minWidth: 150,
      width: 150,
      renderer: {
        type: CustomCellBadgeRenderer,
      },
    },
    {
      header: '답변일',
      name: 'cmntList',
      align: 'center',
      minWidth: 150,
      width: 150,
      formatter: (e: any) => {
        if (PrstsCd.COMPLETE === e.row.prstsCd && 0 < e.value.length && e.row.chgDate) {
          return moment(e.row.chgDate).format(Constant.FORMAT_YMD);
        } else {
          return "-";
        }
      }
    }
  ];

  function handleClickGoWrite() {
    navigate("/info/api/info004/form");
  }

  async function handleClickGoView(e: any) {
    const rowData = e.instance.getRow(e.rowKey);
    const data: PstatModel = ArcGridFunc.removeGridPropsFromData(rowData);
    const response = await PstatService.getInstance().updateInqCnt(data);
    if (response && ResponseResultCode.Y === response.resultCode) {
      navigate("/info/api/info004/detail", { state: JSON.stringify(data) });
    }
  }

  function handleChangeInputSearch(result: ArcInputChangeResult) {
    setSearch({ ...search, titlNm: result.value });
  }

  function handleChangeSelectSearch(event: any) {
    setSearch({ ...search, prstsCd: event.target.value });
  }

  function handleClickReset() {
    setSearch(initialSearch);
  }

  return (
    <div id="container">
      <div className="sub-wrap">
        <ArcTitle title="API 요청 게시판" />
        <div className="col-wrap">
          <div className="col-md-12">
            <div className="srh-filter n-bg-color">
              <ul>
                <li>
                  <ArcSelectbox label="문의상태"
                    name="prstsCd"
                    onChange={handleChangeSelectSearch}
                    selectedValue={search.prstsCd}
                    useDefaultOption={true}
                    useDefaultOptionName="전체"
                    options={prstsOption}
                    callFromSearchPicker={true}

                  />
                </li>
                <li>
                  <ArcInput title="제목 입력"
                    value={search.titlNm ?? ""}
                    id="titlNm"
                    placeholder="제목을 입력하세요."
                    type="w800"
                    onChange={handleChangeInputSearch} />
                </li>
                <li>
                </li>
              </ul>
              <ArcButton type={ButtonType.reset}
                hasIcon={true}
                onClick={handleClickReset} />
            </div>
          </div>
        </div>

        <div className="col-wrap">
          <div className="col-md-12">
            <div className="cont">
              <ArcGrid
                datasource={{
                  readData: { url: '/wp/pstat', method: 'GET', initParams: search }
                }}
                columns={gridColumn}
                rowHeaders={['rowNum']}
                useGridInfoHeader={true}
                usePagination={true}
                onClickRow={handleClickGoView}
              />
              {!UserInfoUtil.hasRole(userInfo, AuthConstant.ADMIN) && (
                <div className="btns2 ar">
                  <ArcButton type={ButtonType.regist} onClick={handleClickGoWrite} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

class CustomCellBadgeRenderer {
  div: HTMLDivElement;

  constructor(props: any) {
    const div = document.createElement('div');
    const span = document.createElement('span');
    div.className = 'tui-grid-cell-content';
    const data = props.grid.getRow(props.rowKey);
    if (PrstsCd.PROCESS === props.value) {
      if (data.cmntList && data.cmntList.length > 0) {
        span.classList.add('p-badge2')
        span.textContent = i18n.t('info.code.prstsCd.PROGRESS');
      } else {
        span.classList.add('p-badge5')
        span.textContent = i18n.t(`info.code.prstsCd.${props.value}`);
      }
    } else if (PrstsCd.COMPLETE === props.value) {
      span.textContent = i18n.t(`info.code.prstsCd.${props.value}`);
      span.classList.add('p-badge1');
    }

    div.append(span);
    this.div = div;
  }

  getElement() {
    return this.div;
  }
}